import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { getRequiredLabItemNames, hasRequiredAttachments, } from '@core/src/nedoShared/features/consultations/helpers/requiredAttachments';
import ChatMessageClient from '../../ChatMessageClient';
export const TestResultsReminder = ({ message, consultation, onActionClick }) => {
    var _a;
    const role = $auth.role.role;
    const { t } = useTranslation();
    const requiredAttachment = (_a = message.attachments) === null || _a === void 0 ? void 0 : _a.find((a) => a.type === 'attachment_requirement');
    const attachments = getRequiredLabItemNames(consultation);
    const attachmentsText = attachments.map((attachment) => `• ${attachment}`).join('\n');
    const newMessage = {
        _id: 'test',
        version: 0,
        created: new Date().toISOString(),
        role_id: 0,
        modified: null,
        chat_id: consultation.chat_id,
        thread_id: null,
        content: `${t('label.upload_test_results_reminder')} \n ${attachmentsText}`,
        attachments: [],
    };
    const actions = [
        {
            type: 'upload-test-result',
            disabled: requiredAttachment && requiredAttachment && (requiredAttachment === null || requiredAttachment === void 0 ? void 0 : requiredAttachment.verified) !== null,
        },
        // { type: 'print-pdf', data: { url: '' } },
    ];
    if (!hasRequiredAttachments(consultation)) {
        return null;
    }
    return (_jsx(ChatMessageClient, { role: role, message: newMessage, actions: actions, onActionClick: onActionClick, showTimestamp: false }));
};
